import {
  environments,
  modes,
  methods,
  cashierStyles,
  scrollSettings,
  amountDisplayStyle,
  amountTransactionStyle,
  displayAccounts,
  RENDER_LIST_TYPES,
  RENDER_LOGO_OR_NAME
} from '@/utils/types'
import bankingConfigs from '@/utils/presets/allPresets/SharedConfigs/banking'

export default (): object => {
  return {
    environment: environments.TEST,
    merchantId: 198003,
    userId: 'PayTestGB',
    locale: 'en',
    sessionId: 123,
    predefinedAmounts: [200, 500, 1000],
    method: 'deposit',
    ...bankingConfigs()
  }
}
